import { userService } from "@features/user/UserService";
import { UserOutputDTO } from '@features/user/types';
import createEntitySlice from "@services/createEntitySlice";

const {
  reducer: UserReducer,
  actions: UserActions,
  fetchAll: fetchUsers,
  fetchById: fetchUserById,
  createEntity: createUser,
  updateEntity: updateUser,
  deleteEntity: deleteUser,
} = createEntitySlice<UserOutputDTO>("User", userService);

export {
  UserReducer,
  UserActions,
  fetchUsers,
  fetchUserById,
  createUser,
  updateUser,
  deleteUser,
}; 